<template>
    <ProductPageSlider :items="reviews" track-class="gap-3" :show-arrows="false">
        <template #default="{ item: review }">
            <ProductReviewHighlightCard
                :review="review"
                class="h-auto! w-[calc(100%/1.15)] shrink-0"
                @on-read-full-review="$emit('on-read-full-review', $event)"
            />
        </template>
    </ProductPageSlider>
</template>

<script setup lang="ts">
import ProductPageSlider from '@/components/sliders/ProductPageSlider.vue';
import ProductReviewHighlightCard from '@/pages/product-page/partials/product-reviews/partials/ProductReviewHighlightCard.vue';
import type { LipscoreProductReviewObject } from '@/types/generated';

type ProductReviewHighlightSliderProps = {
    reviews: LipscoreProductReviewObject[];
};

defineProps<ProductReviewHighlightSliderProps>();

defineEmits<{
    (e: 'on-read-full-review', review: LipscoreProductReviewObject): void;
}>();
</script>
